import { render, staticRenderFns } from "./speed-distribution-chart.vue?vue&type=template&id=f5c3afb4&scoped=true"
import script from "./speed-distribution-chart.vue?vue&type=script&lang=js"
export * from "./speed-distribution-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c3afb4",
  null
  
)

export default component.exports